import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

export const t = key => {
  return translate('gss', key);
};
